module.exports = __webpack_public_path__ + "static/media/delete.458b1f23.svg";